module.exports = __webpack_public_path__ + "img/dice-d20.b6329c2e.svg";